var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParticipantsInactive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 32,
    viewBox: "0 0 26 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66656 10.9999C9.66656 9.15895 11.1589 7.66656 12.9999 7.66656C14.8408 7.66656 16.3332 9.15895 16.3332 10.9999C16.3332 12.8408 14.8408 14.3332 12.9999 14.3332C11.1589 14.3332 9.66656 12.8408 9.66656 10.9999Z",
    fill: "#111D5E",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3332 16.8332C8.57181 16.8332 6.33323 19.0718 6.33323 21.8332C6.33323 22.7537 7.07942 23.4999 7.9999 23.4999H17.9999C18.9204 23.4999 19.6666 22.7537 19.6666 21.8332C19.6666 19.0718 17.428 16.8332 14.6666 16.8332H11.3332Z",
    fill: "#111D5E",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.57245 0.804365C10.4988 0.0964617 15.501 0.0964617 20.4274 0.804365C22.8699 1.15534 24.7517 3.13766 24.9752 5.59509L25.1868 7.92131C25.6758 13.2959 25.6758 18.7039 25.1868 24.0785L24.9752 26.4047C24.7517 28.8621 22.8699 30.8444 20.4274 31.1954C15.501 31.9033 10.4988 31.9033 5.57244 31.1954C3.12996 30.8444 1.24814 28.8621 1.02459 26.4047L0.812979 24.0785C0.324059 18.7039 0.324059 13.2959 0.812979 7.92131L1.02459 5.59509C1.24814 3.13766 3.12996 1.15534 5.57245 0.804365ZM20.0718 3.27895C15.3813 2.60493 10.6185 2.60493 5.92804 3.27895C4.63172 3.46522 3.63296 4.51732 3.51431 5.82157L3.3027 8.1478C2.82749 13.3717 2.82749 18.6281 3.3027 23.852L3.51431 26.1782C3.63296 27.4825 4.63171 28.5346 5.92804 28.7208C10.6185 29.3949 15.3813 29.3949 20.0718 28.7208C21.3681 28.5346 22.3669 27.4825 22.4855 26.1782L22.6971 23.852C23.1723 18.628 23.1723 13.3717 22.6971 8.14779L22.4855 5.82157C22.3669 4.51732 21.3681 3.46522 20.0718 3.27895Z",
    fill: "#111D5E",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParticipantsInactive);
export default __webpack_public_path__ + "static/media/Participants_Inactive.c8f8d81c763e518c76793efead02eac0.svg";
export { ForwardRef as ReactComponent };